import { render, staticRenderFns } from "./xeRankCard.vue?vue&type=template&id=5d850667"
import script from "./xeRankCard.vue?vue&type=script&lang=js"
export * from "./xeRankCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports